import * as actionTypes from '../../actions/BUAP/actionsTypes';

const inititalState = {
    studentdegree: '',
};

const studentDegreeReducer = (state = inititalState, action) => {
    switch (action.type) {
        case actionTypes.SETSTUDENTDEGREE:
            return {
                ...state,
                studentdegree: action.value
            }
        default:
            return state;
    }
}

export default studentDegreeReducer;